import { TJournalData } from '~shared/api/single-journal-data/types'
import { PATHS } from '~shared/constants/paths'
import Image from 'next/image'
import { Social } from '~pages/journal-page/socials'
import { Clock } from '~shared/icons/clock'
import { AuthorBadge } from '~pages/journal-page/author-badge'
import { getJournalPath } from '~shared/utils/getJournalPath'

export const JournalCardMainSection = ({
  journal
}: {
  journal: TJournalData
}) => {
  const { name, description, createdDate, time, tag, author, slug, image } =
    journal

  return (
    <div className='flex flex-col mt-[16px]'>
      {/* Мета + теги + дата/время */}
      <div className='flex flex-row gap-[32px] items-center'>
        <link
          itemProp='mainEntityOfPage'
          href={getJournalPath(tag?.slug, slug)}
        />
        <link itemProp='image' href={image?.url as string} />
        <meta itemProp='headline name' content={name as string} />
        {description && <meta itemProp='description' content={description} />}
        <meta itemProp='author' content={author?.name as string} />
        <meta itemProp='datePublished' content={createdDate as string} />

        <div className='flex w-full gap-[8px] md:gap-[32px] items-center flex-wrap'>
          <span
            className='flex items-center justify-center self-start text-[16px] leading-[19px] px-[10px] h-[37px] text-white rounded-[24px]'
            style={{ backgroundColor: tag?.color || 'black' }}>
            {tag?.name}
          </span>
          {createdDate && (
            <p className='text-[var(--omega)]  text-[12px] pt-[4px]'>
              {createdDate.slice(0, 10).split('-').reverse().join('.')}
            </p>
          )}

          {time && (
            <div className='flex items-center gap-[8px]'>
              <Clock color='black' />
              <span className='text-[var(--omega)] text-[12px] pt-[4px]'>{`${time.split(':')[1]} мин`}</span>
            </div>
          )}
        </div>
      </div>

      {/* Заголовок */}
      <h1
        id='journal-header'
        itemProp='headline'
        className='text-[24px]/[120%] md:text-[48px]/[120%] font-medium my-[16px] md:my-[24px]'>
        {name}
      </h1>

      {/* Автор + Social */}
      <div className='flex relative mb-[24px] md:mb-[32px] 2lg:mb-[56px] justify-between items-center gap-[36px]'>
        {author ? <AuthorBadge author={author} variant='default' /> : <p />}
        <Social journalSlug={slug} tagSlug={tag?.slug ?? ''} />
      </div>

      {/* Обложка */}
      <div className='relative h-[320px] 2lg:h-[400px]'>
        <Image
          fill
          quality={50}
          src={image?.url || '/'}
          alt={image?.alternativeText || ''}
          className='object-cover rounded-[16px]'
        />
      </div>
    </div>
  )
}
